<template>
  <div class="input-group">
    <select
      :value="filterOperator"
      class="form-select"
      style="max-width: 120px"
      @change="onFilterOperatorChange($event.target.value)"
    >
      <option value="=">{{ $t('Equal to') }}</option>
      <option value=">">{{ $t('After') }}</option>
      <option value="<">{{ $t('Before') }}</option>
      <option value=">=">{{ $t('After or equal to') }}</option>
      <option value="<=">{{ $t('Before or equal to') }}</option>
      <option value="!=">{{ $t('Different from') }}</option>
      <option value="is_null">{{ $t('Is empty') }}</option>
      <option value="is_not_null">{{ $t('Is not empty') }}</option>
    </select>
    <input
      :type="field.time ? 'datetime-local' : 'date'"
      :value="field.time ? formatDateTimeForInput(displayValue) : formatDateForInput(displayValue)"
      :id="computedFieldId"
      class="form-control"
      :placeholder="placeholder"
      :readonly="filterOperator === 'is_null' || filterOperator === 'is_not_null'"
      @input="onFilterValueChange($event.target.value)"
      @change="onFilterValueChange($event.target.value)"
    />
  </div>
</template>

<script>
export default {
  name: "FilterFieldDate",
  props: {
    field: {
      type: Object,
      required: true,
    },
    value: {
      type: [String, Date, Array],
      default: null,
    },
    fieldId: {
      type: String,
      default: null,
    },
    filterOperator: {
      type: String,
      default: "=",
    },
  },
  computed: {
    displayValue() {
      if (this.value !== null && this.value !== undefined && this.value !== "") {
        return this.value;
      }
      return null;
    },
    placeholder() {
      return this.field.label || this.field.key || "";
    },
    computedFieldId() {
      return this.fieldId || `filter-date-${this.field.key}`;
    },
  },
  methods: {
    formatDateForInput(value) {
      if (!value) return "";
      if (typeof value === "string") {
        if (value.match(/^\d{4}-\d{2}-\d{2}$/)) {
          return value;
        }
        if (value.includes("T")) {
          return value.split("T")[0];
        }
      }
      if (value instanceof Date) {
        const year = value.getFullYear();
        const month = String(value.getMonth() + 1).padStart(2, "0");
        const day = String(value.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
      }
      return "";
    },
    formatDateTimeForInput(value) {
      if (!value) return "";
      if (typeof value === "string") {
        if (
          value.includes("T") &&
          !value.includes("Z") &&
          !value.includes("+") &&
          !value.match(/T\d{2}:\d{2}-\d{2}:\d{2}$/)
        ) {
          if (value.match(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/)) {
            return value;
          }
          if (value.match(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/)) {
            return value.substring(0, 16);
          }
        }
        if (value.match(/^\d{4}-\d{2}-\d{2}$/)) {
          return value + "T00:00";
        }
        if (value.includes("Z") || value.includes("+") || value.match(/-\d{2}:\d{2}$/)) {
          const match = value.match(/^(\d{4}-\d{2}-\d{2}T\d{2}:\d{2})/);
          if (match) {
            return match[1];
          }
        }
      }
      if (value instanceof Date) {
        const year = value.getFullYear();
        const month = String(value.getMonth() + 1).padStart(2, "0");
        const day = String(value.getDate()).padStart(2, "0");
        const hours = String(value.getHours()).padStart(2, "0");
        const minutes = String(value.getMinutes()).padStart(2, "0");
        return `${year}-${month}-${day}T${hours}:${minutes}`;
      }
      return "";
    },
    onFilterOperatorChange(operator) {
      this.$emit("filter-operator-change", operator);
    },
    onFilterValueChange(newValue) {
      this.$emit("input", newValue);
    },
  },
};
</script>

<style scoped>
.input-group {
  width: 100%;
}
</style>

